import { HttpClient } from 'aurelia-fetch-client';
import { inject } from 'aurelia-framework';
import config from '../config/config';

@inject(HttpClient)
export class FeatureService {
	http: HttpClient;

	constructor(http: HttpClient) {
		this.http = http;
		http.configure(c => {
			c.useStandardConfiguration().withBaseUrl(config.serviceUrl);
		});
	}

	getFeatures() {
		return this.get('/feature/features');
	}

	get(url: string) {
		return this.http.fetch(url)
			.then(r => r.json());
	}
}
